<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-eigentum">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Eigentum" | translate }}</h2>
  </ng-container>

  <div class="btn-group btn-group-sm float-end" data-toggle="buttons" titleActionButtons>
    @if (!isMapsMenuDisabled()) {
      <button class="btn btn-white btn-sm me-2" type="button">
        <cap-maps [mapType]="'eigentum'" [model]="gsId" [tooltip]="'DominierendeGrundstuecke' | translate"></cap-maps>
      </button>
    }
    <label [ngClass]="{ active: eigentumErweitert }" class="btn btn-outline-secondary">
      <input
        (click)="enableEigentumErweitert()"
        autocomplete="off"
        checked="eigentumErweitert"
        class="btn-check"
        id="eigentuemer"
        name="rolle"
        type="radio" />
      {{ "erweitern" | translate }}
    </label>
    <label [ngClass]="{ active: !eigentumErweitert }" class="btn btn-outline-secondary">
      <input
        (click)="disableEigentumErweitert()"
        autocomplete="off"
        checked="!eigentumErweitert"
        class="btn-check"
        id="uebrigeBerechtigte"
        name="rolle"
        type="radio" />
      {{ "kompakt" | translate }}
    </label>
  </div>

  <cap-eigentum-table
    [hasRight]="grundstueckEntry?.permissions?.eigentum && ersterfassungUebergeben"
    [listLoader]="listLoader"
    [navigateToGrundstueck]="navTargetGrundstuecke"
    [showAdressen]="false"
    [showEigentumHeaderWithText]="false">
  </cap-eigentum-table>
</cap-rubrik>
